var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('transition',{attrs:{"name":"box-anim"},on:{"after-leave":_vm.afterLeaveBoxAnim}},[_c('div',{staticClass:"tweet-box"},[_c('div',{staticClass:"root",style:({
      backgroundColor: _vm.mainColor
    }),on:{"click":_vm.showDetail}},[_c('div',{staticClass:"img",style:({
        backgroundImage:("url('" + _vm.dispSrc + "')")
      })},[(_vm.errmsg)?_c('div',{staticClass:"errmsg-box"},[_c('div',{staticClass:"errmsg"},[_vm._v("\n            "+_vm._s(_vm.errmsg)+"\n          ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"cols"},[_c('colorset-mini-view',{attrs:{"colorset":_vm.colorset}})],1)])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-290583b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TweetBox.vue
// module id = null
// module chunks = 